import { c as _c } from "react/compiler-runtime";
import { IcoUser16 } from '@onefootprint/icons';
import type { AuditEventDetail } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
import BaseHoverCard from '../base-hover-card';
import RoleDiff from './role-diff';
type UpdatedRoleProps = {
  detail: AuditEventDetail;
};
const UpdatedRole = t0 => {
  const $ = _c(9);
  const {
    detail
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "events.roles"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("security-logs", t1);
  if (detail.kind !== "update_org_role") {
    return null;
  }
  const t2 = `${detail.data.roleName}`;
  const t3 = detail.data.roleName;
  let t4;
  if ($[1] !== t) {
    t4 = t(_temp);
    $[1] = t;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const t5 = `"${t3}" ${t4}`;
  let t6;
  if ($[3] !== detail) {
    t6 = <RoleDiff detail={detail} />;
    $[3] = detail;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== t2 || $[6] !== t5 || $[7] !== t6) {
    t7 = <BaseHoverCard textTrigger={t2} titleText={t5} titleIcon={IcoUser16}>{t6}</BaseHoverCard>;
    $[5] = t2;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
};
export default UpdatedRole;
function _temp($) {
  return $.rolePermissions;
}